import MuiRadioGroup, { type RadioGroupProps } from "@mui/material/RadioGroup";
import MuiRadio, { type RadioProps } from "@mui/material/Radio";

export type { RadioGroupProps, RadioProps };

export function RadioGroup(props: RadioGroupProps) {
  return <MuiRadioGroup {...props} />;
}

export function Radio(props: RadioProps) {
  return <MuiRadio {...props} />;
}
